(function ($) {
   "use strict";

   class LocationsNav {
      constructor() {
         this.$nav = $(".locations-nav");
         this.$links = this.$nav.find(".js-scroll-to");
         this.$sidebar = this.$nav.closest(".l-archive-career__sidebar");
         this.headerOffset = 171;
         this.lastActiveHref = null;

         if (this.$nav.length) {
            this.init();
         }
      }

      init() {
         this.bindEvents();
         this.updateActiveState();
         this.updateOverflowState();
      }

      bindEvents() {
         this.$links.on("click", (e) => {
            e.preventDefault();
            const targetId = $(e.currentTarget).attr("href");
            this.scrollToTarget(targetId);
         });

         $(window).on("scroll", () => {
            this.updateActiveState();
         });

         $(window).on("load", () => {
            this.updateActiveState();
            this.updateOverflowState();
         });

         $(window).on("resize", () => {
            this.updateOverflowState();
         });

         this.$sidebar.on("scroll", () => {
            this.updateOverflowState();
         });
      }

      isSidebarScrollable() {
         const sidebar = this.$sidebar[0];
         return !!sidebar && sidebar.scrollHeight > sidebar.clientHeight;
      }

      updateOverflowState() {
         const sidebar = this.$sidebar[0];
         if (!sidebar) return;

         const scrollable = this.isSidebarScrollable();
         this.$sidebar
            .toggleClass("has-overflow-top", scrollable && sidebar.scrollTop > 0)
            .toggleClass(
               "has-overflow-bottom",
               scrollable && sidebar.scrollTop + sidebar.clientHeight < sidebar.scrollHeight - 1
            );
      }

      // Garde le lien actif visible en ne faisant défiler que la sidebar (pas la fenêtre)
      scrollSidebarToLink($link) {
         if (!$link.length || !this.isSidebarScrollable()) return;

         const sidebar = this.$sidebar[0];
         const link = $link[0];
         const top = link.offsetTop - sidebar.clientHeight / 2 + link.offsetHeight / 2;

         sidebar.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
      }

      scrollToTarget(targetId) {
         const $target = $(targetId);

         if ($target.length) {
            const targetPosition = $target.offset().top - this.headerOffset;

            $("html, body").animate(
               {
                  scrollTop: targetPosition,
               },
               600,
               "swing"
            );
         }
      }

      updateActiveState() {
         const scrollPos = $(window).scrollTop() + this.headerOffset + 50;

         let activeLocationId = null;
         let activeCountryId = null;

         // First, check locations (more specific)
         $(".c-localisation").each((index, loc) => {
            const $loc = $(loc);
            const locTop = $loc.offset().top;
            const locBottom = locTop + $loc.outerHeight();

            if (scrollPos >= locTop && scrollPos < locBottom) {
               activeLocationId = $loc.attr("id");
               // Also get the parent country
               const $country = $loc.closest(".l-archive-career__country-section");
               if ($country.length) {
                  activeCountryId = $country.attr("id");
               }
               return false;
            }
         });

         // If no location found, check country sections
         if (!activeLocationId) {
            $(".l-archive-career__country-section").each((index, section) => {
               const $section = $(section);
               const sectionTop = $section.offset().top;
               const sectionBottom = sectionTop + $section.outerHeight();

               if (scrollPos >= sectionTop && scrollPos < sectionBottom) {
                  activeCountryId = $section.attr("id");
                  return false;
               }
            });
         }

         // Update active states
         this.$links.removeClass("is-active");

         if (activeLocationId) {
            this.$links.filter(`[href="#${activeLocationId}"]`).addClass("is-active");
         }
         if (activeCountryId) {
            this.$links.filter(`[href="#${activeCountryId}"]`).addClass("is-active");
         }

         const activeId = activeLocationId || activeCountryId;
         const activeHref = activeId ? `#${activeId}` : null;

         if (activeHref !== this.lastActiveHref) {
            this.lastActiveHref = activeHref;
            if (activeHref) {
               this.scrollSidebarToLink(this.$links.filter(`[href="${activeHref}"]`));
            }
         }
      }

      static scrollTo(targetId) {
         const instance = new LocationsNav();
         instance.scrollToTarget(targetId);
      }
   }

   $(document).ready(() => {
      new LocationsNav();
   });

   window.LocationsNav = LocationsNav;
})(jQuery);
